<script setup>
import PagePushCard from '@maison/components/molecules/PagePushCard.vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  link: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  rokkaImg: {
    type: Object,
    default: null,
  },
});

const { t } = useI18n();

const cta = computed(() => {
  return {
    text: t('Search.card.ctaText'),
    target: {
      type: 'page',
      link: props.link,
    },
  };
});
</script>

<template>
  <page-push-card
    :title="title"
    :description="description"
    :image="rokkaImg"
    :cta="cta"
    class="col-span-2 md:col-span-1"
    stacked
    clamped-description
  />
</template>
